module.exports = __webpack_public_path__ + "img/redo.e1f42103.svg";